<template>
  <div class="train-debug">
    <h3>Station</h3>
    <ul>
      <li v-for="(person, index) in station" :key="index">{{person}}</li>
    </ul>
    <h3>Train</h3>
    <div>Transit: {{train.transit}}</div>
    <ul>
      <li v-for="(person, index) in train.passengers" :key="index">{{person}}</li>
    </ul>
    <h3>All People</h3>
    <ul>
      <li v-for="(person, index) in allPeople" :key="index">{{person}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  data: () => ({}),
  computed: {
    station: function() {
      return this.$store.state.station;
    },
    train: function() {
      return this.$store.state.train;
    },
    allPeople: function() {
      return this.$store.getters.allPeople;
    },
    serverCart: function() {
      return this.$store.state.serverCart;
    },
    clientCart: function() {
      return this.$store.getters.clientCart;
    }
  }
};
</script>

<style lang="scss" scoped>
.train-debug {
  font-size: 12px;
  position: fixed;
  right: 0;
  bottom: 0;
  width: 25vw;
  height: 100vh;
  background-color: white;
  z-index: 9999999999999;
  opacity: 0.75;
  pointer-events: none;
}
</style>